module.exports = __webpack_public_path__ + "static/media/introduce_more2.30bcd8ae.png";